import { useMutation } from '@urql/vue';

import type { VerificationResponse, VerificationTypes } from '~/types/verification';

import { verifyAndLinkPhoneNumber } from '~/graphql/documents/core';
import { VERIFICATION_TYPES } from '~/types/verification';

export const useAttemptVerification = () => {
  const { executeMutation } = useMutation(verifyAndLinkPhoneNumber);

  const verifyPhoneNumber = async ({ phoneNumber, code }: { phoneNumber: string; code: string }): Promise<VerificationResponse> => {
    const { error } = await executeMutation({
      input: {
        phoneNumber,
        code,
      },
    });
    if (error) {
      return { success: false, error };
    }
    return { success: true, error: null };
  };

  const attemptVerification = async ({
    verificationMethod,
    authMethodValue,
    pincodeValue,
  }: {
    verificationMethod: VerificationTypes;
    authMethodValue: string;
    pincodeValue: string;
  }) => {
    if (verificationMethod === VERIFICATION_TYPES.PHONE) {
      return await verifyPhoneNumber({
        phoneNumber: authMethodValue,
        code: pincodeValue,
      });
    }
  };

  return { attemptVerification };
};
